// src/components/flight-data/ConnectionLegend.js
import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Reusable component for displaying the connection legend
 * @param {Object} props
 * @param {Object} props.params - Connection parameters
 * @param {Array} props.extraLegends - Optional additional legend items
 */
function ConnectionLegend({ params, extraLegends = [] }) {
  return (
    <Box sx={{ marginBottom: '1rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
      {params.isPriorityFlight ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Box sx={{ width: '1rem', height: '1rem', backgroundColor: 'rgba(249, 182, 18, 0.5)' }}></Box>
          <Typography sx={{ color: '#fff' }}>≤60 min (Priority)</Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Box sx={{ width: '1rem', height: '1rem', backgroundColor: 'rgba(255, 0, 0, 0.5)' }}></Box>
          <Typography sx={{ color: '#fff' }}>≤ {params.hotThreshold} min (Hot)</Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Box sx={{ width: '1rem', height: '1rem', backgroundColor: 'rgba(0, 0, 255, 0.5)' }}></Box>
        <Typography sx={{ color: '#fff' }}>≥ {params.coldThresholdHours} hrs (Cold)</Typography>
      </Box>
      {/* Render any extra legend items */}
      {extraLegends.map((legend, index) => (
        <React.Fragment key={index}>
          {legend}
        </React.Fragment>
      ))}
    </Box>
  );
}

export default ConnectionLegend;